var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5125 1.14978C7.80863 8.98728 6.37838 10.3988 0.375 11.2249C6.37838 12.051 7.80863 13.4625 8.5125 21.3C9.21638 13.4625 10.6463 12.051 16.65 11.2249C10.6463 10.3988 9.21563 8.98728 8.5125 1.14978Z",
    fill: "url(#paint0_linear_1_651)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9752 0.375C18.5732 4.29375 17.7561 4.99987 14.3252 5.41237C17.7557 5.82525 18.5732 6.531 18.9748 10.4501C19.3768 6.531 20.1936 5.82525 23.6248 5.41237C20.1939 4.99987 19.3772 4.29375 18.9752 0.375Z",
    fill: "url(#paint1_linear_1_651)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 13.5503C16.248 17.469 15.4305 18.1744 12 18.5877C15.4305 19.0009 16.248 19.7067 16.65 23.625C17.0516 19.7067 17.8684 19.0009 21.2996 18.5873C17.8684 18.1744 17.052 17.469 16.65 13.5503Z",
    fill: "url(#paint2_linear_1_651)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_651",
    x1: 8.51003,
    y1: 21.2952,
    x2: 8.51003,
    y2: 1.14776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.022,
    stopColor: "#FF9C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#FFB91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5236,
    stopColor: "#FFCE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7678,
    stopColor: "#FFDB3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_651",
    x1: 18.9743,
    y1: 10.4557,
    x2: 18.9743,
    y2: 0.373275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FAD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0389,
    stopColor: "#73B202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2625,
    stopColor: "#87CC0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4933,
    stopColor: "#96DE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#9EE91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1ED1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_651",
    x1: 16.6539,
    y1: 23.625,
    x2: 16.6539,
    y2: 13.5513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D0C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#930C90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#B30DAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4208,
    stopColor: "#CC0DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5949,
    stopColor: "#DD0ED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#E80EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0EE5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.2c88b3145decdd86b0888b58db8440d9.svg";
export { ForwardRef as ReactComponent };